// extracted by mini-css-extract-plugin
export default {"border-bottom-dotted__border":"border-bottom-dotted__border_x585YuTT"};